import type { ScholarshipPlayer } from '../../../../types/scholarships';
import type { RosterSport } from '../../../../constants/sport';
import { pitchingParts, profileParts } from './playerScouting';

const Line = ({ parts }: { parts: string[] }) => {
  if (parts.length === 0) return null;
  const text = parts.join(' · ');
  // The cell truncates; the title keeps the whole line one hover away.
  return (
    <span className="scholarship-players__meta" title={text}>
      {text}
    </span>
  );
};

export const PlayerScoutingLines = ({
  player,
  sport,
}: {
  player: ScholarshipPlayer;
  sport: RosterSport;
}) => (
  <>
    <Line parts={profileParts(player)} />
    <Line parts={pitchingParts(player, sport)} />
  </>
);
